import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgBetSingle = (props) => /* @__PURE__ */ _jsx("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	width: 18.375,
	height: 22.594,
	viewBox: "0 0 18.375 22.594",
	...props,
	children: /* @__PURE__ */ _jsxs("g", {
		"data-name": "Icon - Bet Single",
		transform: "translate(0 0)",
		children: [
			/* @__PURE__ */ _jsx("path", {
				"data-name": "Path 5539",
				d: "M17.625,21.844V2.157A1.407,1.407,0,0,0,16.219.75H2.156A1.407,1.407,0,0,0,.75,2.157V21.844l4.812-2.813,3.625,2.813,3.626-2.813Z",
				fill: "none",
				stroke: "currentColor",
				strokeLinecap: "round",
				strokeLinejoin: "round",
				strokeWidth: 1.5
			}),
			/* @__PURE__ */ _jsx("path", {
				"data-name": "Path 5540",
				d: "M5.3,5.672a.352.352,0,1,1,0-.7",
				fill: "none",
				stroke: "currentColor",
				strokeWidth: 1.5
			}),
			/* @__PURE__ */ _jsx("path", {
				"data-name": "Path 5541",
				d: "M5.3,5.672a.352.352,0,1,0,0-.7",
				fill: "none",
				stroke: "currentColor",
				strokeWidth: 1.5
			}),
			/* @__PURE__ */ _jsx("line", {
				"data-name": "Line 956",
				x2: 4.836,
				transform: "translate(8.915 5.32)",
				fill: "none",
				stroke: "currentColor",
				strokeLinecap: "round",
				strokeLinejoin: "round",
				strokeWidth: 1.5
			})
		]
	})
});
export { SvgBetSingle as ReactComponent };
